export { default as TabsDashboard } from "./TabsDashboard";
